// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';

import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from './message-list';
import addToCart from '@core/scripts/components/actions/add-to-cart';
import Landmark from '@core/scripts/components/landmark-adapter';
import openIntoCartLayer from '@core/scripts/components/actions/open-into-cart-layer';
import WindowManager from '@core/scripts/components/window-manager';
import NitroEventHelper from '@core/scripts/helper/nitro-event-helper';
import NitroEventFactory from '../tracking/nitro-event-factory';
import {Button} from '@bonprix/design-system';
import Expi, {ExperimentVariant} from "@core/scripts/modules/expi";


export default function CartButton({
                                       texts,
                                       product,
                                       pointOfSaleIdOverride,
                                       filterTrackingValue,
                                       rankingTrackingValue,
                                       pageViewId,
                                       origin = 'cart-button',
                                   }) {
    const [currentStyle, setCurrentStyle] = useState(product.currentStyle);
    const [currentItem, setCurrentItem] = useState(product.currentItem);
    const [currentItemOption, setCurrentItemOption] = useState(product.currentItemOption);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const subscriptions = [
            MessageBroker.subscribe(ProductMessages.CHANGED, handleProductUpdate),
            MessageBroker.subscribe(ProductMessages.ADD_TO_CART_ERROR, ({currentItemOption}) => {
                setError(currentItemOption === null || currentItemOption === undefined);
            }),
            MessageBroker.subscribe(ProductMessages.SELECTION_NEEDED, ({itemOptionNeeded}) =>
                setError(itemOptionNeeded)
            ),
        ];

        return () =>
            subscriptions.forEach((subscription) => {
                return MessageBroker.unsubscribe(subscription);
            });
    });

    const handleProductUpdate = ({style, item, itemOption}) => {
        if (item !== undefined) {
            setCurrentItem(item);
        }
        if (style !== undefined) {
            setCurrentStyle(style);
        }
        if (itemOption !== undefined) {
            setCurrentItemOption(itemOption);
            setError(false);
        }
    };

    const onNotificationButtonClick = () => {
        const itemAvailability = currentItem?.availability;
        const tempNotAvailable = itemAvailability?.tempNotAvailable;
        const itemOptionNeeded = tempNotAvailable && !currentItemOption;

        MessageBroker.publish(ProductMessages.SELECTION_NEEDED, {itemOptionNeeded});

        if (!itemOptionNeeded) {
            MessageBroker.publish(ProductMessages.AVAILABILITY_REMINDER_LAYER_CHANGED, {open: true});
        }

        Landmark.sendClickLandmark(
            `adp\\availability_mail\\\\${currentItem.itemNumber}\\\\${product.channelId}\\${product.shopId}\\${
                product.masterStyleId
            }\\${product.styleId}\\${currentItemOption?.id || currentItem?.id}`
        );
    };

    const openSideSheet=()=>{
        MessageBroker.publish(ProductMessages.OPEN_SIDE_SHEET_FOR_SOLD_OUT_ARTICLE);
    }

    const onAddToCartClick = async (currentItem, currentItemOption) => {
        MessageBroker.publish(ProductMessages.HIDE_SUBMIT_ERROR);
        if (!currentItemOption) {
            return MessageBroker.publish(ProductMessages.ADD_TO_CART_ERROR, {currentItemOption});
        }

        setLoading(true);
        const currentTabData = WindowManager.getCurrentTabData();
        const pointOfSaleId = currentTabData?.pointOfSaleId?.toString() || '';
        const currentShopId = product.searchResultArticle ? 0 : product.shopId;
        const cartSummary = await addToCart(
            product.styleId,
            currentShopId,
            currentItem.id,
            currentItem.itemNumber,
            currentItemOption?.id,
            currentItemOption?.name,
            currentItem.promotion,
            null,
            origin,
            currentItemOption?.price?.unified?.value,
            1,
            pointOfSaleIdOverride || pointOfSaleId,
            product.masterStyleId,
            filterTrackingValue,
            rankingTrackingValue
        );

        if (cartSummary) {
            openIntoCartLayer(
                currentItemOption.id,
                currentShopId,
                null,
                null,
                -78,
                null,
                'adp',
                product.channelId,
                () => setLoading(false)
            );
            NitroEventHelper.trigger(
                NitroEventHelper.EventType.ADD_TO_CART,
                NitroEventFactory.createAddToCartEvent(
                    product,
                    currentStyle,
                    currentItem,
                    currentItemOption,
                    '',
                    filterTrackingValue,
                    pageViewId
                )
            );
        } else {
            MessageBroker.publish(ProductMessages.SHOW_SUBMIT_ERROR, {error: texts.ada_add_to_cart_error});
            setLoading(false);
        }
    };

    const availabilitySource = (currentItemOption || currentItem || currentStyle || product).availability;
    const price = (currentItemOption || currentItem).price;

    const style = Expi.getVariant("EXPI-65") === ExperimentVariant.VARIANT_B ? "h-10" : "";

    if (product.cartCta.allowAvailabilityNotification && availabilitySource.tempNotAvailable) {
        return (
            <>
                <Button
                    onClick={() => onNotificationButtonClick()}
                    variant="primary"
                    fullWidth={true}
                    icon='newsletter'
                    iconPosition="end"
                    className="product__cart-button--notify"
                >
                    <span className={'content-center ' +style}>{texts.ada12_button_article_notify_by_mail}</span>
                </Button>
            </>

        );
    }
    if (currentItem.availability.soldOut) {
        return (
            <>
                <Button
                    onClick={() => openSideSheet()}
                    variant="primary"
                    fullWidth={true}
                    icon='similar-products'
                    iconPosition="end"
                    className="product__cart-button--notify"
                >
                    <span className={'content-center ' + style}>{texts.ada15_other_customers_bought}</span>
                </Button>
            </>

        );
    }

    return (
        <>
            <Button
                disabled={!availabilitySource.available || price?.current?.unknownPrice}
                onClick={() => onAddToCartClick(currentItem, currentItemOption)}
                loading={loading}
                variant="primary"
                fullWidth={true}
                icon='cart'
                iconPosition="end"
                className="product__cart-button--available"
            >
                <span className={'content-center ' + style}>{texts.article_addtobasket}</span>
            </Button>
        </>
    );
}
